"use strict";
// import { datadogRum } from '@datadog/browser-rum';
// import packageJSON from '../../package.json';
// import { readEnvFile } from '.';
// const { DATADOG_APP_ID, DATADOG_CLIENT_TOKEN, DISPATCHER_BFF_URL } =
//   readEnvFile();
const allowedEnvironments = ['dev', 'preview', 'live'];
if (typeof window !== 'undefined' &&
    allowedEnvironments.includes(process.env.ENVIRONMENT ?? 'dev')) {
    // datadogRum.init({
    //   service: 'wlcaf-dispatcher',
    //   env: process.env.ENVIRONMENT,
    //   applicationId: DATADOG_APP_ID,
    //   clientToken: DATADOG_CLIENT_TOKEN,
    //   version: packageJSON.version,
    //   trackViewsManually: false,
    //   site: 'datadoghq.eu',
    //   sessionSampleRate: 100,
    //   sessionReplaySampleRate: 100,
    //   trackUserInteractions: true,
    //   trackResources: true,
    //   trackLongTasks: true,
    //   defaultPrivacyLevel: 'allow',
    //   allowedTracingUrls: [DISPATCHER_BFF_URL],
    // });
}
